<div class="ion-header ion-hide-lg-up h">
  <header-main></header-main>
</div>

<main class="ion-content" fullscreen>
  <header class="ion-hide-lg-down g">
    <header-desktop></header-desktop>
    <h1 color="white">
      How it works
    </h1>
  </header>

  <div class="articles">
    <div class="article">
      <div class="article-bg article-bg--blue-turquoise">
        <div class="container-fluid">
          <div class="ion-grid">
            <div class="row">
              <div class="col col-xs-12 col-sm-6">
                <div class="articles-content">
                  <h2>Gigs</h2>
                  <p>Whether you are a freelancer or contractor already in the gig economy. A Full Time Employee looking to boost your income opportunities through a side hustle. Or simply wanting to power up your passion, we have the gigs for you.</p>
                  <a href="/how-it-works/gig-economy"><button class="button-round button-tertiary">Find out more</button></a>
                </div>
              </div>
              <div class="col col-xs-12 col-sm-6">
                <a href="/how-it-works/gig-economy"><img src="assets/images/how-it-works/gigs.jpg" alt="Gigs"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="article">
      <div class="article-bg article-bg--white">
        <div class="container-fluid">
          <div class="ion-grid">
            <div class="row">
              <div class="col col-xs-12 col-sm-6">
                <div class="articles-content">
                  <h2>Jobs</h2>
                  <p>Adding the reputation & Intelligence into finding first class candidates. Whilst enabling job hunters to build their platform reputation to land dream jobs & contracts.</p>
                  <a href="/how-it-works/jobs-site"><button class="button-round button-tertiary">Find out more</button></a>
                </div>
              </div>
              <div class="col col-xs-12 col-sm-6">
                <a href="/how-it-works/jobs-site"><img src="assets/images/how-it-works/jobs.jpg" alt="jobs"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="article">
      <div class="article-bg article-bg--coral">
        <div class="container-fluid">
          <div class="ion-grid">
            <div class="row">
              <div class="col col-xs-12 col-sm-6">
                <div class="articles-content">
                  <h2>Volunteers</h2>
                  <p>Putting the ease, convenience and recognition into volunteering and finding volunteers.</p>
                  <a href="/how-it-works/volunteers"><button class="button-round button-white">Find out more</button></a>
                </div>
              </div>
              <div class="col col-xs-12 col-sm-6">
                <a href="/how-it-works/volunteers"><img src="assets/images/how-it-works/volunteers.jpg" alt="Volunteers"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="article">
      <div class="article-bg article-bg--ultra-violet">
        <div class="container-fluid">
          <div class="ion-grid">
            <div class="row">
              <div class="col col-xs-12 col-sm-6">
                <div class="articles-content">
                  <h2>Promote</h2>
                  <p>Advertise your business or freelance service whilst growing your reputation through our platforms integrated ratings and reviews.</p>
                  <a href="/how-it-works/promote-advertising"><button class="button-round button-tertiary">Find out more</button></a>
                </div>
              </div>
              <div class="col col-xs-12 col-sm-6">
                <a href="/how-it-works/promote-advertising"><img src="assets/images/how-it-works/promoter.jpg" alt="Promote"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="ion-hide-lg-down">
    <footer-desktop></footer-desktop>
  </footer>
</main>

<footer class="ion-footer ion-hide-lg-up">
  <footer-main></footer-main>
</footer>
